/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutationVariables =
  Types.Exact<{
    input:
      | ReadonlyArray<Types.InvestorFirmRelationshipCreateInput>
      | Types.InvestorFirmRelationshipCreateInput;
  }>;

export type AddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation = {
  readonly __typename?: 'Mutation';
  readonly createInvestorRelationships?: {
    readonly __typename?: 'CreateInvestorRelationshipsPayload';
    readonly investorFirmRelationship?: ReadonlyArray<{
      readonly __typename?: 'InvestorFirmRelationship';
      readonly relationshipStatus: Types.RolodexRecordStatus;
      readonly relationshipType: Types.RelationshipType;
    }> | null;
  } | null;
};

export type AddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutationVariables =
  Types.Exact<{
    input: Types.AdminCreateInvestorRelationshipsInput;
  }>;

export type AddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation = {
  readonly __typename?: 'Mutation';
  readonly adminCreateInvestorRelationships?: {
    readonly __typename?: 'AdminCreateInvestorRelationshipsPayload';
    readonly investorFirmRelationship?: ReadonlyArray<{
      readonly __typename?: 'InvestorFirmRelationship';
      readonly relationshipStatus: Types.RolodexRecordStatus;
      readonly relationshipType: Types.RelationshipType;
    }> | null;
  } | null;
};

export type CreateUnderwriterEmployeeRelationshipFragment = {
  readonly __typename?: 'InvestorFirmRelationship';
  readonly relationshipStatus: Types.RolodexRecordStatus;
  readonly relationshipType: Types.RelationshipType;
};

export type CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQueryVariables = Types.Exact<{
  searchText: Types.Scalars['String']['input'];
  firmId: Types.Scalars['UUID']['input'];
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  take?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQuery = {
  readonly __typename?: 'Query';
  readonly underwriterEmployees?: {
    readonly __typename?: 'UnderwriterEmployeesCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'UnderwriterEmployee';
      readonly id: string;
      readonly name?: string | null;
      readonly employeeKey: string;
      readonly userAccount?: {
        readonly __typename?: 'UserAccount';
        readonly name?: string | null;
      } | null;
    }> | null;
    readonly pageInfo: {
      readonly __typename?: 'CollectionSegmentInfo';
      readonly hasNextPage: boolean;
    };
  } | null;
};

export type CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQueryVariables =
  Types.Exact<{
    tenantId: Types.Scalars['UUID']['input'];
    searchText: Types.Scalars['String']['input'];
    firmId: Types.Scalars['UUID']['input'];
    skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
    take?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  }>;

export type CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQuery = {
  readonly __typename?: 'Query';
  readonly adminUnderwriterEmployees?: {
    readonly __typename?: 'AdminUnderwriterEmployeesCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'UnderwriterEmployee';
      readonly id: string;
      readonly name?: string | null;
      readonly employeeKey: string;
      readonly userAccount?: {
        readonly __typename?: 'UserAccount';
        readonly name?: string | null;
      } | null;
    }> | null;
    readonly pageInfo: {
      readonly __typename?: 'CollectionSegmentInfo';
      readonly hasNextPage: boolean;
    };
  } | null;
};

export type InvestorFirmSalesCoverage_UnderwriterEmployeeFragment = {
  readonly __typename?: 'UnderwriterEmployee';
  readonly id: string;
  readonly name?: string | null;
  readonly employeeKey: string;
  readonly userAccount?: {
    readonly __typename?: 'UserAccount';
    readonly name?: string | null;
  } | null;
};

export const CreateUnderwriterEmployeeRelationshipFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CreateUnderwriterEmployeeRelationship' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'InvestorFirmRelationship' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipType' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const InvestorFirmSalesCoverage_UnderwriterEmployeeFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorFirmSalesCoverage_UnderwriterEmployee' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UnderwriterEmployee' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {
        kind: 'Name',
        value: 'AddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationships',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'InvestorFirmRelationshipCreateInput' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createInvestorRelationships' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'input' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'investorFirmRelationship' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CreateUnderwriterEmployeeRelationship' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CreateUnderwriterEmployeeRelationship' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'InvestorFirmRelationship' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipType' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutationFn =
  Apollo.MutationFunction<
    AddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation,
    AddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutationVariables
  >;

/**
 * __useAddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation__
 *
 * To run a mutation, you first call `useAddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInvestorFirmSalesCoverageCreateUnderwriterEmployeeRelationshipsMutation, { data, loading, error }] = useAddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation,
    AddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation,
    AddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutationVariables
  >(AddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsDocument, options);
}
export type AddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutationHookResult =
  ReturnType<typeof useAddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation>;
export type AddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutationResult =
  Apollo.MutationResult<AddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation>;
export type AddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutationOptions =
  Apollo.BaseMutationOptions<
    AddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation,
    AddInvestorFirmSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutationVariables
  >;
export const AddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {
        kind: 'Name',
        value: 'AddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationships',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AdminCreateInvestorRelationshipsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminCreateInvestorRelationships' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'investorFirmRelationship' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CreateUnderwriterEmployeeRelationship' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CreateUnderwriterEmployeeRelationship' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'InvestorFirmRelationship' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipType' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutationFn =
  Apollo.MutationFunction<
    AddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation,
    AddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutationVariables
  >;

/**
 * __useAddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation__
 *
 * To run a mutation, you first call `useAddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInvestorFirmSalesCoverageAdminCreateUnderwriterEmployeeRelationshipsMutation, { data, loading, error }] = useAddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation,
    AddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation,
    AddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutationVariables
  >(AddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsDocument, options);
}
export type AddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutationHookResult =
  ReturnType<
    typeof useAddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation
  >;
export type AddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutationResult =
  Apollo.MutationResult<AddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation>;
export type AddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutationOptions =
  Apollo.BaseMutationOptions<
    AddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation,
    AddInvestorFirmSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutationVariables
  >;
export const CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchText' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firmId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'underwriterEmployees' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'take' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'or' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'name' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'contains' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'searchText' },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'employeeKey' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'contains' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'searchText' },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'userAccount' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'name' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'contains' },
                                            value: {
                                              kind: 'Variable',
                                              name: { kind: 'Name', value: 'searchText' },
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'salesCoverage' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'none' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'firmId' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'eq' },
                                        value: {
                                          kind: 'Variable',
                                          name: { kind: 'Name', value: 'firmId' },
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'EnumValue', value: 'EFFECTIVE' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'InvestorFirmSalesCoverage_UnderwriterEmployee',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorFirmSalesCoverage_UnderwriterEmployee' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UnderwriterEmployee' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQuery__
 *
 * To run a query within a React component, call `useCrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      firmId: // value for 'firmId'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useCrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQuery(
  baseOptions: Apollo.QueryHookOptions<
    CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQuery,
    CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQueryVariables
  > &
    (
      | {
          variables: CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQuery,
    CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQueryVariables
  >(CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchDocument, options);
}
export function useCrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQuery,
    CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQuery,
    CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQueryVariables
  >(CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchDocument, options);
}
// @ts-ignore
export function useCrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQuery,
    CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQuery,
  CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQueryVariables
>;
export function useCrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQuery,
        CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQuery | undefined,
  CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQueryVariables
>;
export function useCrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQuery,
        CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQuery,
    CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQueryVariables
  >(CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchDocument, options);
}
export type CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQueryHookResult = ReturnType<
  typeof useCrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQuery
>;
export type CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchLazyQueryHookResult =
  ReturnType<typeof useCrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchLazyQuery>;
export type CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchSuspenseQueryHookResult =
  ReturnType<typeof useCrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchSuspenseQuery>;
export type CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQueryResult =
  Apollo.QueryResult<
    CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQuery,
    CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQueryVariables
  >;
export const CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {
        kind: 'Name',
        value: 'CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearch',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchText' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firmId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminUnderwriterEmployees' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'take' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'or' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'name' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'contains' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'searchText' },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'employeeKey' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'contains' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'searchText' },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'userAccount' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'name' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'contains' },
                                            value: {
                                              kind: 'Variable',
                                              name: { kind: 'Name', value: 'searchText' },
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'salesCoverage' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'none' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'firmId' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'eq' },
                                        value: {
                                          kind: 'Variable',
                                          name: { kind: 'Name', value: 'firmId' },
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'EnumValue', value: 'EFFECTIVE' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'InvestorFirmSalesCoverage_UnderwriterEmployee',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorFirmSalesCoverage_UnderwriterEmployee' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UnderwriterEmployee' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQuery__
 *
 * To run a query within a React component, call `useCrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      searchText: // value for 'searchText'
 *      firmId: // value for 'firmId'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useCrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQuery(
  baseOptions: Apollo.QueryHookOptions<
    CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQuery,
    CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQueryVariables
  > &
    (
      | {
          variables: CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQuery,
    CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQueryVariables
  >(CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchDocument, options);
}
export function useCrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQuery,
    CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQuery,
    CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQueryVariables
  >(CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchDocument, options);
}
// @ts-ignore
export function useCrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQuery,
    CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQuery,
  CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQueryVariables
>;
export function useCrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQuery,
        CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQuery | undefined,
  CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQueryVariables
>;
export function useCrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQuery,
        CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQuery,
    CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQueryVariables
  >(CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchDocument, options);
}
export type CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQueryHookResult =
  ReturnType<typeof useCrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQuery>;
export type CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchLazyQueryHookResult =
  ReturnType<typeof useCrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchLazyQuery>;
export type CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchSuspenseQueryHookResult =
  ReturnType<typeof useCrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchSuspenseQuery>;
export type CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQueryResult =
  Apollo.QueryResult<
    CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQuery,
    CrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchQueryVariables
  >;
